var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageType === 'OEGG')?_c('register-form'):(_vm.currentPageType === 'register-rockbowl')?_c('rockbowl-form'):(_vm.currentPageType === 'icsmge-visum-application')?_c('visa-form'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }